import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Project } from '../classes/project';


@Injectable()
export class SalesDashboardService {

  dashBouardIsActive = new Subject<any>();
  changeSelectedProject = new Subject<any>(); //possibly rename
  openImg = new Subject<any>();
  slectedImg: object = {};
  selectedProject;
  dashBoard: boolean = false;
  shareProjectId: string = null;
  shareProject = new Subject<any>();
  projTodeleteIdSubj = new Subject<any>();

  constructor() { }

  showDashboard() {
    this.dashBoard = true;
    this.dashBouardIsActive.next(this.dashBoard);
  }

//possibly rename
  openSelectedProject(selectedProject){
    this.selectedProject = selectedProject;
    this.changeSelectedProject.next(this.selectedProject);
  }

  openImgModal(img){
    this.slectedImg = img;
    this.openImg.next(this.slectedImg);
  }

  hideDashbouard() {
    this.dashBoard = false;
    this.dashBouardIsActive.next(this.dashBoard);
  }

  setSelectedProjectId(id){
    this.shareProjectId = id;
  }

  getSelectedProjectId(){
    return this.shareProjectId;
  }

  clearSelectedProjId(){
    this.shareProjectId = null;
  }

  confirmProjectDelete(id){
      this.projTodeleteIdSubj.next(id);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/sales-dashboard.service.ts